import { useSearchParams } from 'next/navigation';

export default function useInheritParams(path: string, inheritParams: string[]) {
    const searchParams = useSearchParams();
    const pathParts = path.split('?');
    const pathParams = new URLSearchParams(pathParts[1]);

    const overrides = new Map<string, string>();

    if (typeof window !== 'undefined') {
        let sessionParams:URLSearchParams|undefined;

        try {
            sessionParams = new URLSearchParams(window.sessionStorage.getItem('paramStr') || '');
        } catch(e) {
            console.error(e);
        }

        if (sessionParams) {
            const keys = sessionParams.keys();
            let key = keys.next().value;

            while (key) {
                if (inheritParams.indexOf(key) !== -1) {
                    const value = sessionParams.get(key);
                    if (value) {
                        overrides.set(key, value);
                    }
                }
                key = keys.next().value;
            }
        }
    }

    if (searchParams) {
        inheritParams.forEach((param) => {
            const value = searchParams.get(param);
            if (value) {
                overrides.set(param, value);
            }
        });
    }

    overrides.forEach((value, key) => {
        const keysToDelete: string[] = [];
        pathParams.forEach((_, paramKey) => {
            if (paramKey.toLowerCase() === key.toLowerCase()) {
                keysToDelete.push(paramKey);
            }
        });
        keysToDelete.forEach((k) => pathParams.delete(k));
        pathParams.set(key, value);
    });

    if (/\/subscribe\/checkout\/(flepz|purchase\/satellite)/gi.test(path)) {
        const satCode = searchParams.get('satcode') || searchParams.get('satCode');

        if (satCode) {
            if (pathParams.has('promoCode') || pathParams.has('promocode')) {
                pathParams.delete('promoCode');
                pathParams.delete('promocode');
                pathParams.set('promoCode', satCode);
            } else {
                pathParams.delete('programCode');
                pathParams.delete('programcode');
                pathParams.set('programcode', satCode);
            }
        }
    } else if (/\/subscribe\/checkout\/purchase\/(streaming|satellite)/gi.test(path)) {
        const strCode = searchParams.get('strcode') || searchParams.get('strCode');

        if (strCode) {
            if (pathParams.has('programCode') || pathParams.has('programcode')) {
                pathParams.delete('programCode');
                pathParams.delete('programcode');
                pathParams.set('programcode', strCode);
            } else {
                pathParams.delete('promoCode');
                pathParams.delete('promocode');
                pathParams.set('promoCode', strCode);
            }
        }
    }

    const nextQuery = pathParams.toString();
    const nextHref = nextQuery ? `${pathParts[0]}?${nextQuery}` : pathParts[0];

    return nextHref;
}
